import Clarity from '@microsoft/clarity';

const initializeClarity = (): any => {
  if (process.env.NODE_ENV !== 'production') return

  const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID || '';
  if (projectId) Clarity.init(projectId);
}

export { initializeClarity }
